import { useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { usePartnerOfferQuery } from 'hooks/queries/usePartnerOfferQuery';

interface Props {
  isPrefetch?: boolean;
}

export const usePartnerOffer = (props?: Props) => {
  const history = useHistory();
  const location = useLocation();

  const newTab = useRef<null | Window>(null);

  const queries = queryString.parse(location.search);

  const partnerOfferQuery = usePartnerOfferQuery({
    enabled: Boolean(props?.isPrefetch),
  });

  const handleOpenPartnerOffer = () => {
    const newTabUrl = partnerOfferQuery.isSuccess
      ? partnerOfferQuery.data.popup_url
      : '';

    if (
      !partnerOfferQuery.isLoading &&
      (!partnerOfferQuery.isSuccess || !partnerOfferQuery.data.popup_url)
    ) {
      partnerOfferQuery.refetch().then(({ isSuccess, data }) => {
        if (newTab.current && isSuccess) {
          newTab.current.window.location.href = data.popup_url;
        }
      });
    }

    history.replace(
      `/finder?${queryString.stringify({
        ...queries,
        partner_offer: 1,
      })}`
    );

    newTab.current = window.open(newTabUrl, '_blank');

    if (!partnerOfferQuery.isSuccess || !partnerOfferQuery.data.popup_url) {
      newTab.current?.document.write('Loading....');
    }
  };

  return {
    handleOpenPartnerOffer,
  };
};
